import { ReadonlyVec3, vec3 } from 'gl-matrix';
import { DvfDisplayRangeMm } from '~/domain/dvf/dvfDisplayRange';
import { DvfField, dvfDisplacementAt } from '~/domain/dvf/dvfField';
import { inferno } from '~/utils/colormap';

const MIN_OPACITY = 0.15;
const MAX_OPACITY = 0.6;

// A displacement magnitude as an inferno RGBA, or null below the range so only the window shows.
export function heatmapRgba(
    magnitudeMm: number,
    range: DvfDisplayRangeMm
): [number, number, number, number] | null {
    const span = range.highMm - range.lowMm;
    if (span <= 0) {
        return null;
    }
    const t = (magnitudeMm - range.lowMm) / span;
    if (t <= 0) {
        return null;
    }
    const clamped = Math.min(t, 1);
    const [r, g, b] = inferno(clamped);
    const alpha = Math.round(
        255 * (MIN_OPACITY + (MAX_OPACITY - MIN_OPACITY) * clamped)
    );
    return [r, g, b, alpha];
}

// Writes one RGBA pixel per lattice point into a row-major buffer; points outside the field stay transparent.
export function paintHeatmap(
    rgba: Uint8ClampedArray,
    points: readonly ReadonlyVec3[],
    field: DvfField,
    range: DvfDisplayRangeMm
): void {
    for (let i = 0; i < points.length; i++) {
        const px = i * 4;
        const disp = dvfDisplacementAt(field, points[i]);
        const color = disp ? heatmapRgba(vec3.length(disp), range) : null;
        if (color) {
            rgba[px] = color[0];
            rgba[px + 1] = color[1];
            rgba[px + 2] = color[2];
            rgba[px + 3] = color[3];
        } else {
            rgba[px + 3] = 0;
        }
    }
}
